import React, { FC } from 'react'

import { WorkspaceLogo } from '@sketch/components'

import { Container, WorkspaceName } from './ProfileAvatar.styles'

export interface ProfileAvatarProps {
  workspaceName: string
  avatar?: string | null
  className?: string
}

export const ProfileAvatar: FC<ProfileAvatarProps> = ({
  workspaceName,
  avatar,
  className,
}) => {
  return (
    <Container className={className}>
      <WorkspaceLogo size="88px" workspaceName={workspaceName} src={avatar} />
      <WorkspaceName>{workspaceName}</WorkspaceName>
    </Container>
  )
}
